import { FileUpload } from "@roc/ui";

export const getMultipartFile = (fileUpload: FileUpload) => {
  const blob = fileUpload.file.slice(0, fileUpload.file.size, fileUpload.file.type);
  return new File([blob], fileUpload.name, { type: fileUpload.file.type });
}